export default {
  skDebtCcpIp2: state => state.skDebtCcpIp,
  skDebtCcpButtonFilter: state => state.skDebtCcpButtonFilter,
}
